<template>
  <div style="background: gray">
    <div>card不包含padding，需额外添加</div>
    <SjCard style="height: 100px">
      <div style="padding: 10px">
        这是normal
      </div>
    </SjCard>

    <SjCard style="margin-top:10px;height: 100px" type="index">
      <div style="padding: 10px">
        这是index
      </div>
    </SjCard>

    <SjCard style="margin-top:10px;height: 100px" type="content">
      <div style="padding: 10px">
        这是
      </div>
    </SjCard>

    <SjCard style="margin-top:10px;height: 100px" type="dark">
      <div style="padding: 10px;color: white">
        这是dark
      </div>
    </SjCard>

    <SjCard style="margin-top:10px;height: 100px" type="transparent">
      <div style="padding: 10px;font-weight: 100">
        transparent 123321
      </div>
    </SjCard>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less"></style>
